import { Component } from "@angular/core";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";

@Component({
    // tslint:disable-next-line:component-selector
    selector: "formly-field-surveyreadonly",
    template: `<input
    class="form-control"
    [formlyAttributes]="field"
    [class.is-invalid]="showError"
  />`,
    standalone: false
})
export class FormlyFieldSurveyReadOnlyComponent extends FieldType<FieldTypeConfig> {}
